import fs from 'node:fs';
import { spawnSync } from 'node:child_process';
import process from 'node:process';
import { packageName } from './brand.js';
import { clearUpdateCache } from './update-check.js';

type PackageManager = 'bun' | 'pnpm' | 'npm';

function detectPackageManager(): PackageManager {
  const rawPath = process.argv[1];
  // Check the raw path first (symlink like ~/.bun/bin/canary), then the resolved target
  const paths = [rawPath];
  try {
    paths.push(fs.realpathSync(rawPath));
  } catch {
    // realpathSync can fail if symlink is broken — continue with raw path only
  }
  for (const raw of paths) {
    const p = raw.replace(/\\/g, '/');
    if (p.includes('.bun/') || p.includes('/bun/')) return 'bun';
    if (p.includes('.pnpm/') || p.includes('/pnpm/')) return 'pnpm';
  }
  return 'npm';
}

const UPGRADE_COMMANDS: Record<PackageManager, string[]> = {
  bun: ['bun', 'add', '-g', `${packageName}@latest`],
  pnpm: ['pnpm', 'add', '-g', `${packageName}@latest`],
  npm: ['npm', 'install', '-g', `${packageName}@latest`],
};

export async function runUpgrade(): Promise<void> {
  const pm = detectPackageManager();
  const cmd = UPGRADE_COMMANDS[pm];

  console.log(`Upgrading ${packageName} via ${pm}...\n`);

  const result = spawnSync(cmd[0], cmd.slice(1), {
    stdio: 'inherit',
    cwd: process.cwd(),
    shell: process.platform === 'win32',
    windowsHide: true,
  });

  if (result.error) {
    console.error(`\nFailed to run ${pm}:`, result.error.message);
    process.exit(1);
  }

  if (result.status !== 0) {
    console.error(`\nUpgrade failed (exit code ${result.status}).`);
    process.exit(result.status ?? 1);
  }

  await clearUpdateCache();
  console.log(`\nSuccessfully upgraded ${packageName}.`);
}
